import moment from 'moment';
import constants from '../../helpers/constants';

const deepDiffMapper = (function () {
  return {
    VALUE_CREATED: 'created',
    VALUE_UPDATED: 'updated',
    VALUE_DELETED: 'deleted',
    VALUE_UNCHANGED: 'unchanged',
    map(obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw 'Invalid argument. Function given, object expected.';
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        return {
          type: this.compareValues(obj1, obj2),
          data: obj1 === undefined ? obj2 : obj1,
        };
      }

      const diff = {};

      for (const key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        let value2;

        if (obj2[key] !== undefined) {
          value2 = obj2[key];
        }

        diff[key] = this.map(obj1[key], value2);
      }
      for (const key in obj2) {
        if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;
    },
    compareValues(value1, value2) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
        return this.VALUE_UNCHANGED;
      }
      if (value1 === undefined) {
        return this.VALUE_CREATED;
      }
      if (value2 === undefined) {
        return this.VALUE_DELETED;
      }

      return this.VALUE_UPDATED;
    },
    isFunction(x) {
      return Object.prototype.toString.call(x) === '[object Function]';
    },
    isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    },
    isDate(x) {
      return Object.prototype.toString.call(x) === '[object Date]';
    },
    isObject(x) {
      return Object.prototype.toString.call(x) === '[object Object]';
    },
    isValue(x) {
      return !this.isObject(x) && !this.isArray(x);
    },
  };
}());

const tasksHelpersShared = {
  prepareProjectTasksData(obj) {
    const tasks = obj?.tasks?.data || obj.tasks;
    const links = obj?.tasks?.links || obj.links;

    if (obj._onlyForWorkloadCalculation) {
      tasks.forEach(task => {
        task.resources = obj.resourcesToTasks[task.id] || [];

        if (_.isString(task.start_date)) {
          task.start_date = moment(task.start_date, constants.TASK_DATES_FORMAT).toDate();
        }

        if (_.isString(task.end_date)) {
          task.end_date = moment(task.end_date, constants.TASK_DATES_FORMAT).toDate();
        }

        if (_.isString(task.estimation)) {
          task.estimation = parseFloat(task.estimation);
        }
      });

      return {
        id: +obj.id,
        workloadData: obj.workloadData,
        resourcesToTasks: obj.resourcesToTasks || {},
        _onlyForWorkloadCalculation: !!obj._onlyForWorkloadCalculation,
        tasks,
      };
    }

    if (!obj.customValues) {
      obj.customValues = {};
    }

    if (!obj.defaultCustomValues) {
      obj.defaultCustomValues = {};
    }

    if (!obj.resourcesToTasks) {
      obj.resourcesToTasks = {};
    }

    if (!obj.commentActions) {
      obj.commentActions = {};
    }

    tasks.forEach(task => {
      task.status = (obj.customValues[task.id] && obj.customValues[task.id].status) || obj.defaultCustomValues.status;
      task.priority = (obj.customValues[task.id] && obj.customValues[task.id].priority) || obj.defaultCustomValues.priority;
      task.jira_key = (obj.customValues[task.id] && obj.customValues[task.id].jira_key) || '';
      task.resources = obj.resourcesToTasks[task.id] || [];

      task.newComments = obj.commentActions[task.id] || task.newComments || null;

      if (task.deadline) {
        task.deadline = moment(task.deadline, constants.TASK_DATES_FORMAT).toDate();
      }

      if (_.isString(task.start_date)) {
        task.start_date = moment(task.start_date, constants.TASK_DATES_FORMAT).toDate();
      }

      if (_.isString(task.end_date)) {
        task.end_date = moment(task.end_date, constants.TASK_DATES_FORMAT).toDate();
      }

      if (_.isString(task.estimation)) {
        task.estimation = parseFloat(task.estimation);
      }

      if (task.parent === null) {
        task.parent = 0;
      }
    });

    return {
      id: +obj.id,
      customValues: obj.customValues || {},
      defaultCustomValues: obj.defaultCustomValues || {},
      resourcesToTasks: obj.resourcesToTasks || {},
      commentActions: obj.commentActions || {},
      is_archived: obj.is_archived || 0,
      workloadData: obj.workloadData || {},
      _onlyForWorkloadCalculation: !!obj._onlyForWorkloadCalculation,
      tasks,
      links,
    };
  },

};

export default tasksHelpersShared;
